import React from "react";
import { createRoot } from "react-dom/client";
import FadiusWatchAttend from "./App.jsx";
import { MarketingSite } from "./marketing/MarketingSite.jsx";
import { VenueConfirmationPage } from "./venue-confirmation/VenueConfirmationPage.jsx";
import "./index.css";

const path = window.location.pathname.replace(/\/+$/, "") || "/";
const productPreview = path === "/app" || path === "/preview";
const venueConfirmation = path.startsWith("/v/");

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {venueConfirmation ? <VenueConfirmationPage /> : productPreview ? <FadiusWatchAttend /> : <MarketingSite />}
  </React.StrictMode>,
);
